<template>
  <div
    class="image-list"
    :ref="attrName"
    v-viewer="{title: false}"
  >
    <image-item
      v-for="(image, index) in images"
      :key="index"
      :image="image"
    >
      <div class="image-item-actions">
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(image, index)"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
      </div>
    </image-item>
  </div>
</template>
<script>
import { ImageItem } from '@/components/upload';

export default {
  components: { ImageItem },
  props: {
    images: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
    attrName: {
      type: String,
      default: 'imagesview',
    },
  },
  methods: {
    handlePictureCardPreview(file, index) {
      const viewer = this.$refs[this.attrName].$viewer;
      viewer.view(index);
    },
  },
};
</script>
